"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const Toggle = _ref => {
  let {
    className,
    prefix,
    buttons,
    iconOnly,
    onClick,
    fluid,
    activeIndex,
    ...others
  } = _ref;
  function renderToggleButtons() {
    return buttons.map((buttonProps, index) => {
      const {
        ssrIcon,
        text,
        disabled,
        ...other
      } = buttonProps;
      const isActive = activeIndex === index;
      const baseClass = "".concat(prefix, "toggle__button");
      const cssStyles = (0, _classnames.default)(baseClass, iconOnly && ssrIcon && "".concat(baseClass, "--icon-only"), isActive && "".concat(baseClass, "--active"), fluid && "".concat(baseClass, "--fluid"));
      return _react.default.createElement("button", _extends({
        key: index,
        disabled: disabled && !isActive,
        className: cssStyles,
        "aria-pressed": isActive ? 'true' : 'false',
        onClick: e => onClick(e, index)
      }, other), iconOnly && ssrIcon !== undefined && ssrIcon && _react.default.createElement(_ssrIcon.default, {
        prefix: prefix,
        paths: ssrIcon
      }), text && _react.default.createElement("span", {
        className: "".concat(prefix, "toggle__button-label")
      }, text));
    });
  }
  const classes = (0, _classnames.default)("".concat(prefix, "toggle"), className);
  return _react.default.createElement("div", _extends({
    className: classes
  }, others), buttons && renderToggleButtons());
};
Toggle.defaultProps = {
  prefix: '',
  activeIndex: 0
};
var _default = Toggle;
exports.default = _default;